import { Box } from '@mui/material';
import { isInvertorHybrid } from '../../shared/device-details-utils';
import StepComponent from './step.component';
import { STEP_IDS } from '../config-wizard-steps';
import StepContainer from './step-container.component';
import { useMediaQuery, useTheme } from '@mui/material';

export default function PVPanelsStep({ stepProps, ...props }) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('lg'));

  const { formData, schema, uiSchema } = stepProps;
  const pvArraysProps = {
    ...stepProps,
    formData: { pvArrays: formData.pvArrays },
    schema: schema.pvArrays,
    uiSchema: uiSchema.pvArrays,
    liveValidate: !!props.state?.get(props?.stepId)?.pvArrays,
    skipContainer: true,
    formContext: {
      diffObj: { pvArrays: stepProps.formContext.diffObj.pvArrays },
    },
  };
  const pvArraysRetrofitProps = {
    ...stepProps,
    formData: { pvArraysRetrofit: formData.pvArraysRetrofit },
    schema: schema.pvArraysRetrofit,
    uiSchema: uiSchema.pvArraysRetrofit,
    liveValidate: !!props.state?.get(stepProps?.stepId)?.pvArraysRetrofit,
    skipContainer: true,
    formContext: {
      diffObj: { pvArraysRetrofit: stepProps.formContext.diffObj.pvArraysRetrofit },
    },
  };
  const retrofitPVMeasurementProps = {
    ...stepProps,
    formData: { retrofitPVMeasurement: formData.retrofitPVMeasurement },
    schema: schema.retrofitPVMeasurement,
    uiSchema: uiSchema.retrofitPVMeasurement,
    liveValidate: !!props.state?.get(stepProps?.stepId)?.retrofitPVMeasurement,
    skipContainer: true,
    formContext: {
      diffObj: { retrofitPVMeasurement: stepProps.formContext.diffObj.retrofitPVMeasurement },
    },
  };

  const useUnbiasedEstimatorsProps = {
    ...stepProps,
    formData: { useUnbiasedEstimators: formData.useUnbiasedEstimators },
    schema: schema.useUnbiasedEstimators,
    uiSchema: uiSchema.useUnbiasedEstimators,
    liveValidate: !!props.state?.get(stepProps?.stepId)?.useUnbiasedEstimators,
    skipContainer: true,
    formContext: {
      diffObj: { useUnbiasedEstimators: stepProps.formContext.diffObj.useUnbiasedEstimators },
    },
  };

  const inverter = props.state.get(STEP_IDS.CONVERTER) || props[STEP_IDS.CONVERTER];
  const showPvArrays = isInvertorHybrid(inverter);
  return (
    <StepContainer sx={{ px: fullScreen ? 0 : 4 }}>
      {showPvArrays ? (
        <Box>
          <StepComponent
            partialKey="pvArrays"
            {...props}
            stepProps={pvArraysProps}
          />
        </Box>
      ) : null}
      <Box>
        <StepComponent
          partialKey="pvArraysRetrofit"
          {...props}
          stepProps={pvArraysRetrofitProps}
        />
      </Box>
      <Box>
        <StepComponent
          partialKey="retrofitPVMeasurement"
          {...props}
          stepProps={retrofitPVMeasurementProps}
        />
      </Box>
      <Box>
        <StepComponent
          partialKey="useUnbiasedEstimators"
          {...props}
          stepProps={useUnbiasedEstimatorsProps}
        />
      </Box>
    </StepContainer>
  );
}
